// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7498) return "static/chunks/7498-71288d5d36b7c193.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3902":"f5e996fce3dac4c0","8873":"fd7e6b5abda4801b"}[chunkId] + ".js";
};